import BatchName from '../../../../../components/batches/batch-list-columns/column-definitions/batch-name';
import BatchNote from '../../../../../components/batches/batch-list-columns/column-definitions/batch-note';
import ShipmentCount from '../../../../../components/batches/batch-list-columns/column-definitions/shipment-count';
import ProcessedDate from '../../../../../components/batches/batch-list-columns/column-definitions/processed-date';
import CreatedDate from '../../../../../components/batches/batch-list-columns/column-definitions/created-date';
import AssignedTo from '../../../../../components/batches/batch-list-columns/column-definitions/assigned-to';
import ShipmentsRatedCost from '../../../../../components/batches/batch-list-columns/column-definitions/shipments-rated-cost';
import PackingSlipsPrintedCount from '../../../../../components/batches/batch-list-columns/column-definitions/packing-slips-printed-count';
import PrintedDate from '../../../../../components/batches/batch-list-columns/column-definitions/printed-date';
import ProcessingStatus from '../../../../../components/batches/batch-list-columns/column-definitions/processing-status';

const tabsToPropsMap = {
  open: {
    columns: [
      { ...BatchName, index: 0 },
      { ...ShipmentCount, index: 1 },
      { ...CreatedDate, index: 2 },
      { ...BatchNote, index: 3 },
      { ...AssignedTo, index: 4 },
      { ...ShipmentsRatedCost, index: 5 },
      { ...PackingSlipsPrintedCount, index: 6 },
      { ...PrintedDate, index: 7 },
    ],
  },
  processed: {
    columns: [
      { ...BatchName, index: 0 },
      { ...ShipmentCount, index: 1 },
      { ...CreatedDate, index: 2 },
      { ...AssignedTo, index: 3 },
      { ...PackingSlipsPrintedCount, index: 4 },
      { ...BatchNote, index: 5 },
      { ...ProcessedDate, index: 6 },
      { ...PrintedDate, index: 7 },
      { ...ProcessingStatus, index: 8 },
    ],
  },
  archived: {
    columns: [
      { ...BatchName, index: 0 },
      { ...ShipmentCount, index: 1 },
      { ...CreatedDate, index: 2 },
      { ...AssignedTo, index: 3 },
      { ...PackingSlipsPrintedCount, index: 4 },
      { ...BatchNote, index: 5 },
      { ...PrintedDate, index: 6 },
      { ...ProcessingStatus, index: 7 },
    ],
  },
  'advanced-search': {
    columns: [
      { ...BatchName, index: 0 },
      { ...ShipmentCount, index: 1 },
      { ...CreatedDate, index: 2 },
      { ...BatchNote, index: 3 },
      { ...AssignedTo, index: 4 },
      { ...ShipmentsRatedCost, index: 5 },
      { ...PackingSlipsPrintedCount, index: 6 },
      { ...PrintedDate, index: 7 },
      { ...ProcessingStatus, index: 8 },
    ],
  },
};

export default tabsToPropsMap;
